import { operationalListStatus } from '../../contracts/operational-list-policy.generated';
/** Shared display label for canonical and historical audit action values. */
export function billingAuditActionLabel(action?: string | null): string {
  return operationalListStatus({ action }, 'billingAudit')
    .replaceAll('_', ' ')
    .replace(/\b\w/g, (char) => char.toUpperCase());
}
